window.tagCommanderModule = {}

window.tagCommanderModule.callTrackTcEvent = function (category, action, label) {
    if (typeof (trackEvent) != 'undefined') {
        trackEvent(
            { category: category, action: action, label: label });
    }
}

window.tagCommanderModule.navigationEvents = {
    menu_event: function (label) {
        window.tagCommanderModule.callTrackTcEvent('Navigation', 'Menu', label);
    },
    account_event: function (label) {
        window.tagCommanderModule.callTrackTcEvent('Navigation', 'Clic', label);
    },
    download_account_excel: function (label) {
        window.tagCommanderModule.callTrackTcEvent('Téléchargement', 'EXCEL', label);
    },
    download_account_pdf: function (label) {
        window.tagCommanderModule.callTrackTcEvent('Téléchargement', 'PDF', label);
    },
    request_change_address: function () {
        window.tagCommanderModule.callTrackTcEvent('Navigation', 'Clic', 'Demande modification adresse');
    },
    request_change_rib: function () {
        window.tagCommanderModule.callTrackTcEvent('Navigation', 'Clic', 'Demande modification RIB');
    },
    change_password: function () {
        window.tagCommanderModule.callTrackTcEvent('Navigation', 'Clic', 'Modification mot de passe');
    }

};

window.tagCommanderModule.formEvents = {
    change_address: function () {
        window.tagCommanderModule.callTrackTcEvent('Formulaire', 'Clic', 'Modifier adresse');
    },
    change_rib: function () {
        window.tagCommanderModule.callTrackTcEvent('Formulaire', 'Clic', 'Modification RIB');
    },
    pref_comm_validation: function (label) {
        window.tagCommanderModule.callTrackTcEvent('Formulaire', 'Validation', label);
    },

};

window.tagCommanderModule.documentationEvents = {
    download_doc: function (format,label) {
        window.tagCommanderModule.callTrackTcEvent('Téléchargement', format, label);
    }
};